import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';

export const selectSeasonalFeatured = state => state.seasonalFeatured;

export const selectSeasonalFeaturedConfig = createSelector(
  selectSeasonalFeatured,
  seasonalFeatured => seasonalFeatured.config,
);

export const selectSeasonalFeaturedIsLoading = createSelector(
  selectSeasonalFeatured,
  seasonalFeatured => seasonalFeatured.isLoading,
);

export const selectSeasonalFeaturedIsLoaded = createSelector(
  selectSeasonalFeatured,
  seasonalFeatured => seasonalFeatured.isLoaded,
);

export const selectSeasonalFeaturedPlacements = createSelector(
  selectSeasonalFeatured,
  seasonalFeatured => seasonalFeatured.placements,
);

export const selectSeasonalFeaturedPlacementsToDisplay = createSelector(
  selectSeasonalFeaturedPlacements,
  placements => shuffle(placements).slice(0, 2),
);
